import MasterContainer from "./MasterContainer";

const store = [
    new MasterContainer(),
]

export default store;
